import { render, staticRenderFns } from "./manageUserType.vue?vue&type=template&id=5d3b90d6&"
import script from "./manageUserType.vue?vue&type=script&lang=js&"
export * from "./manageUserType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports